import { orderBy } from 'firebase/firestore'
import { FirestoreRepository } from '@/core/firebase/repository'
import { clubSubcollections } from '@/core/firebase/paths'
import { ClubRoleSchema, type ClubRole } from '@/core/models/club-role'

export class ClubRolesRepository extends FirestoreRepository<typeof ClubRoleSchema> {
  constructor(clubId: string) {
    super(clubSubcollections.roles(clubId), ClubRoleSchema)
  }

  listAll(): Promise<ClubRole[]> {
    return this.list(orderBy('createdAt', 'asc'))
  }
}
